import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { PaginatedResponse, NightDiffConfiguration } from "@shared/models";
import { Observable } from "rxjs";
import { ToHttpHeadersService } from "../utils";
import { LABELS } from "@shared/constants";
import { ListActions } from '@shared/enums';

@Injectable({
	providedIn: 'root'
})
export class NightDiffConfigurationService {

	readonly url = `/api/v1/payroll/night-diff`;
	readonly http = inject(HttpClient);
	readonly toHttpHeaders = inject(ToHttpHeadersService);
	readonly label = LABELS.NIGHT_DIFFERENTIAL;

	list(params?: Partial<NightDiffConfiguration>): Observable<PaginatedResponse<NightDiffConfiguration>> {
		return this.http.get<PaginatedResponse<NightDiffConfiguration>>(`${this.url}`, { params });
	}

	post(data: NightDiffConfiguration): Observable<NightDiffConfiguration> {
		return this.http.post<NightDiffConfiguration>(this.url, data, this.toHttpHeaders.generateHeaders(ListActions.CREATE, this.label));
	}

	put(data: NightDiffConfiguration): Observable<NightDiffConfiguration> {
		return this.http.put<NightDiffConfiguration>(this.url, data, this.toHttpHeaders.generateHeaders(ListActions.UPDATE, this.label));
	}

	delete(id: number): Observable<NightDiffConfiguration> {
		return this.http.delete<NightDiffConfiguration>(`${this.url}/${id}`, this.toHttpHeaders.generateHeaders(ListActions.DELETE, this.label));
	}

}